import React from 'react';
import { Link } from 'react-router-dom';
import Input from '../shared/input';
import Submit from '../shared/submit';
import request from '../../request';

export default class Login extends React.Component {
  constructor() {
    super();
    this.state = { email: '' };
  }

  async send() {
    let { email } = this.state;
    try {
      let { message } = await request({
        url: 'auth/forgot',
        body: { email },
      });
      this.setState({ message, email: '' });
    } catch (e) {
      this.setState({ message: e.message || e });
    }
  }

  render() {
    let { email, message } = this.state;

    return (
      <div id="main">
        <h5>Forgot Password</h5>
        {message ? <p className="error">{message}</p> : null}
        <Input
          name="email"
          value={email}
          placeholder="Email address"
          onChange={email => this.setState({ email })}
        />
        <Submit id="proceed" onClick={() => this.send()} />
        <p id="options">
          <Link to="/auth/login/">← Back</Link>
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/auth/forgot.js